import MarketoStatus  from "./components/MarketoStatus";

class Login {
  constructor() {
    this.loginEl = document.getElementById( 'login' );
    if (!this.loginEl) {
      return;
    }

    this.firstContainer = document.getElementsByClassName( 'container' )[0];

    this.init();
  }

  init() {
    this.setImageHeight();
    this.calculateOffset();
    this.setInputFieldType();
    this.keyboardEvents();
    if (this.checkIfBackButton()) {
      this.modifyLoginNavigation();
    }

    const ww = window.innerWidth;

    window.addEventListener( 'resize', () => {
      if (ww !== window.innerWidth) {
        // Only change if width has changed.
        this.setImageHeight();
        this.calculateOffset();
      }
    } );

    window.addEventListener( 'orientationchange', () => {
      this.setImageHeight();
      this.calculateOffset();
    } );
  }

  /**
   * Fire validation on specific keyboard events.
   */
  keyboardEvents() {
    const ids = ['user_login', 'user_pass'];
    ids.forEach( id => {
      const field = document.getElementById( id );
      if (field) {
        field.addEventListener( 'blur', () => this.validateField( field ) );
        field.addEventListener( 'keyup', () => this.validateField( field ) );
      }
    } );
  }

  /**
   * Validate field.
   * @param {HTMLElement} field The input field.
   */
  validateField(field) {
    if ('email' === field.type) {
      const pattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (pattern.test( field.value )) {
        field.classList.remove( 'invalid' );
      } else {
        field.classList.add( 'invalid' );
      }
    } else if (field.value.trim() === '') {
      field.classList.add( 'invalid' );
    } else if (field.classList.contains( 'invalid' )) {
      field.classList.remove( 'invalid' );
    }
  }

  /**
   * Set input field type to email.
   */
  setInputFieldType = () => {
    const field = document.getElementById( 'user_login' );
    if( field ) {
      field.setAttribute( 'type', 'email' );
    }
  };

  /**
   * Set the background image height.
   */
  setImageHeight = () => {
    if (!this.loginEl) {
      return;
    }
    document.body.style.setProperty( '--login-height', `${this.loginEl.clientHeight}px` );
  };

  /**
   * Calculate the offset, so the login card is centered.
   */
  calculateOffset = () => {
    if (window.matchMedia( '(min-width: 1329px)' ).matches) {
      const offsetX = Math.abs( this.loginEl.querySelector( '.login-card' ).offsetLeft - this.firstContainer.offsetLeft );
      document.body.style.setProperty( '--login-card-offset-x', `${offsetX + 12}px` );
    } else {
      document.body.style.removeProperty( '--login-card-offset-x' );
    }
  };

  checkIfBackButton = () => {
    return Array.from( document.body.classList )?.some( r => ['login-action-lostpassword', 'login-action-checkemail'].includes( r ) );
  };

  modifyLoginNavigation = () => {
    const btl = document.querySelector( '.back-to-login' );
    if (btl) {
      btl.innerText = window.login_variables.login_label;
    }

    // Remove navigation.
    const nav = document.getElementById('nav');
    if( nav ) {
      nav.remove();
    }
  };
}

window.addEventListener( 'DOMContentLoaded', () => {
  new Login();
  new MarketoStatus( '.login-card', '#loginform', false );
} );





